/**
 * BBT4VW Taxonomy AJAX Filter
 * Enables filtering without page reload
 */
(function() {
  'use strict';

  const TaxonomyAjaxFilter = {
    selectors: {
      filterWidget: '.taxonomy-nav-widget',
      filterLinks: '.taxonomy-nav-list a',
      clearLinks: '.taxonomy-widget-title .clear-filter',
      productGrid: '.collection_prod',
      pagination: '.pagi-nav',
      breadcrumb: '.bread-crumb',
      pageTitle: '.title-page h2',
      taxonomyGroups: '#TaxonomyGroups',
      taxonomyChapters: '#TaxonomyChapters',
      sidebar: '.filter_sidebar_general, .filter_sidebar'
    },

    init: function() {
      this.bindEvents();
      this.handlePopState();
    },

    bindEvents: function() {
      // Delegate click events on filter links
      document.addEventListener('click', (e) => {
        const link = e.target.closest(this.selectors.filterLinks + ', ' + this.selectors.clearLinks);
        if (link && link.href && !link.href.includes('javascript:')) {
          e.preventDefault();
          this.loadFilteredContent(link.href);
        }
      });

      // Delegate click events on pagination links within product grid
      document.addEventListener('click', (e) => {
        const paginationLink = e.target.closest('.pagi-nav a');
        if (paginationLink && paginationLink.href) {
          e.preventDefault();
          this.loadFilteredContent(paginationLink.href);
        }
      });
    },

    handlePopState: function() {
      window.addEventListener('popstate', (e) => {
        if (e.state && e.state.taxonomyFilter) {
          this.loadFilteredContent(window.location.href, false);
        }
      });
    },

    loadFilteredContent: function(url, pushState = true) {
      // Show loading state
      this.showLoading();

      fetch(url, {
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      })
      .then(response => {
        if (!response.ok) throw new Error('Network response was not ok');
        return response.text();
      })
      .then(html => {
        this.updateContent(html, url, pushState);
        this.hideLoading();
      })
      .catch(error => {
        console.error('Filter error:', error);
        // Fallback to regular navigation
        window.location.href = url;
      });
    },

    updateContent: function(html, url, pushState) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      // Update product grid
      const newProductGrid = doc.querySelector(this.selectors.productGrid);
      const currentProductGrid = document.querySelector(this.selectors.productGrid);
      if (newProductGrid && currentProductGrid) {
        currentProductGrid.innerHTML = newProductGrid.innerHTML;
      }

      // Update taxonomy filters in sidebar (both desktop and mobile)
      this.updateFilters(doc);

      // Update breadcrumb
      const newBreadcrumb = doc.querySelector(this.selectors.breadcrumb);
      const currentBreadcrumb = document.querySelector(this.selectors.breadcrumb);
      if (newBreadcrumb && currentBreadcrumb) {
        currentBreadcrumb.innerHTML = newBreadcrumb.innerHTML;
      }

      // Update page title if changed
      const newTitle = doc.querySelector(this.selectors.pageTitle);
      const currentTitle = document.querySelector(this.selectors.pageTitle);
      if (newTitle && currentTitle) {
        currentTitle.innerHTML = newTitle.innerHTML;
      }

      // Update browser URL and history
      if (pushState) {
        history.pushState({ taxonomyFilter: true }, '', url);
      }

      // Update document title
      const newDocTitle = doc.querySelector('title');
      if (newDocTitle) {
        document.title = newDocTitle.textContent;
      }

      // Scroll to top of products
      const productSection = document.querySelector('.collection-page-sidebar');
      if (productSection) {
        productSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }

      // Re-initialize any product-related JS (like quickview, etc.)
      this.reinitializeProductScripts();
    },

    updateFilters: function(doc) {
      // Update desktop sidebar filters
      const desktopSidebars = document.querySelectorAll('.filter_sidebar_general');
      desktopSidebars.forEach(sidebar => {
        const newGroups = doc.querySelector('.filter_sidebar_general ' + this.selectors.taxonomyGroups);
        const currentGroups = sidebar.querySelector(this.selectors.taxonomyGroups);
        if (newGroups && currentGroups) {
          currentGroups.outerHTML = newGroups.outerHTML;
        }

        const newChapters = doc.querySelector('.filter_sidebar_general ' + this.selectors.taxonomyChapters);
        const currentChapters = sidebar.querySelector(this.selectors.taxonomyChapters);
        if (newChapters) {
          if (currentChapters) {
            currentChapters.outerHTML = newChapters.outerHTML;
          } else {
            // Insert chapters after groups
            const groups = sidebar.querySelector(this.selectors.taxonomyGroups);
            if (groups) {
              groups.insertAdjacentHTML('afterend', newChapters.outerHTML);
            }
          }
        } else if (currentChapters) {
          // Remove chapters if not in new content
          currentChapters.remove();
        }
      });

      // Update mobile sidebar filters
      const mobileSidebars = document.querySelectorAll('.filter_sidebar');
      mobileSidebars.forEach(sidebar => {
        const newGroups = doc.querySelector('.filter_sidebar ' + this.selectors.taxonomyGroups);
        const currentGroups = sidebar.querySelector(this.selectors.taxonomyGroups);
        if (newGroups && currentGroups) {
          currentGroups.outerHTML = newGroups.outerHTML;
        }

        const newChapters = doc.querySelector('.filter_sidebar ' + this.selectors.taxonomyChapters);
        const currentChapters = sidebar.querySelector(this.selectors.taxonomyChapters);
        if (newChapters) {
          if (currentChapters) {
            currentChapters.outerHTML = newChapters.outerHTML;
          } else {
            const groups = sidebar.querySelector(this.selectors.taxonomyGroups);
            if (groups) {
              groups.insertAdjacentHTML('afterend', newChapters.outerHTML);
            }
          }
        } else if (currentChapters) {
          currentChapters.remove();
        }
      });
    },

    showLoading: function() {
      const productGrid = document.querySelector(this.selectors.productGrid);
      if (productGrid) {
        productGrid.style.opacity = '0.5';
        productGrid.style.pointerEvents = 'none';
        
        // Add loading spinner
        if (!document.querySelector('.taxonomy-loading')) {
          const loader = document.createElement('div');
          loader.className = 'taxonomy-loading';
          loader.innerHTML = '<div class="taxonomy-spinner"></div>';
          productGrid.parentElement.insertBefore(loader, productGrid);
        }
      }
    },

    hideLoading: function() {
      const productGrid = document.querySelector(this.selectors.productGrid);
      if (productGrid) {
        productGrid.style.opacity = '';
        productGrid.style.pointerEvents = '';
      }
      
      const loader = document.querySelector('.taxonomy-loading');
      if (loader) {
        loader.remove();
      }
    },

    reinitializeProductScripts: function() {
      // Trigger any necessary re-initialization for product cards
      // This handles things like quickview, wishlist, etc.
      if (typeof window.SPR !== 'undefined' && typeof window.SPR.registerCallbacks === 'function') {
        window.SPR.registerCallbacks();
        window.SPR.initRatingHandler();
        window.SPR.initDomEls();
        window.SPR.loadProducts();
        window.SPR.loadBadges();
      }

      // Dispatch custom event for other scripts to hook into
      document.dispatchEvent(new CustomEvent('taxonomy:filtered', {
        detail: { url: window.location.href }
      }));
    }
  };

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => TaxonomyAjaxFilter.init());
  } else {
    TaxonomyAjaxFilter.init();
  }
})();

